<script setup lang="ts">
  import { ref } from 'vue';
  import { BaseIconSvg } from '@shared/components';
  import { BaseInfiniteScroll } from '@shared/components';

  const props = withDefaults(
    defineProps<{
      relatedPlace: 'top' | 'bottom';
    }>(),
    {
      relatedPlace: 'bottom',
    }
  );

  const emit = defineEmits<{
    (e: 'change', val: 'top' | 'bottom'): void;
  }>();

  const showLocationModal = ref(false);
</script>

<template>
  <div className="product-drawer__location">
    <div class="location-header">
      <div><BaseIconSvg class="czdizhi" type="czdizhi" :size="14" color="#333" />展示位置</div>
      <div @click="showLocationModal = true">
        {{ props.relatedPlace === 'top' ? '页面上部' : '页面底部' }}
        <BaseIconSvg type="czicon-test7" :size="20" color="#979797" />
      </div>
    </div>

    <div class="location-modal" v-if="showLocationModal">
      <div class="scroll-box2">
        <BaseInfiniteScroll :pullUpLoad="false">
          <template #scroll-content>
            <div class="products">
              <div class="item product-box" @click="() => emit('change', 'top')">
                <div class="name">
                  页面上部
                  <p>位于第一个栏目下方</p>
                </div>
                <div :class="relatedPlace === 'top' ? 'selected' : 'unselected'">&#xe667;</div>
              </div>
              <div class="item product-box" @click="() => emit('change', 'bottom')">
                <div class="name">
                  页面底部
                  <p>位于一日谈下方</p>
                </div>
                <div :class="relatedPlace === 'bottom' ? 'selected' : 'unselected'">&#xe667;</div>
              </div>
            </div>
            <div className="preview">
              <div className="title">位置预览图</div>
              <img
                v-if="relatedPlace === 'bottom'"
                src="https://webcdn.tengmoney.com/usm/FvnJcK_btJ5AW2eD3uaJpwJVntCp-641-720.png"
              />
              <img v-else src="https://webcdn.tengmoney.com/usm/FtXQh5SrVX_8MhRe9p8NKKv3F_99-641-720.png" />
            </div>
          </template>
        </BaseInfiniteScroll>
      </div>
      <div class="btn2" @click="showLocationModal = false">完成</div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .location-header {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    border-top: 1px #f5f5f5;
    border-bottom: 1px solid #f5f5f5;
    border-top: 1px solid #f5f5f5;
    margin-bottom: 15px;

    > div {
      display: flex;
      align-items: center;
    }

    .czdizhi {
      margin-right: 0.12rem;
    }
  }

  .location-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 3001;
    box-sizing: border-box;
    width: 100%;
    height: 100vh;
    background: #f5f5f5;

    * {
      box-sizing: border-box;
    }

    .item {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      // padding: 0.37rem 1.00rem 0.37rem 0.40rem;
      padding: 0.24rem 1.45rem 0.24rem 0.3rem;
      border-bottom: 1px solid #ebebeb;
    }

    .scroll-box {
      height: 100%;
    }

    .scroll-box2 {
      height: calc(~'100vh - 0.88rem');
    }

    .selected,
    .unselected {
      position: absolute;
      right: 0.25rem;
    }

    .selected {
      font-family: cz-iconfont;
      font-size: 0.38rem;
      color: #3078db;
    }

    .unselected {
      width: 0.36rem;
      height: 0.36rem;
      color: transparent;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(220, 220, 220, 1);
      border-radius: 50%;
    }

    .products {
      background-color: #fff;
      border-top: 0.2rem solid #f5f5f5;
      border-bottom: 0.2rem solid #f5f5f5;

      .item {
        height: 1.28rem;
      }

      .name {
        font-size: 0.28rem;
        font-weight: 400;
        color: rgba(17, 17, 17, 1);

        p {
          height: 0.3rem;
          line-height: 0.3rem;
          margin-top: 0.1rem;
          font-size: 0.22rem;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
        }
      }
    }

    .preview {
      padding: 0.24rem 0.3rem;
      background-color: #fff;

      .title {
        margin-bottom: 0.24rem;
      }

      img {
        width: 100%;
        height: auto;
        padding: 0.2rem 0.23rem 0.3rem;
      }
    }

    .btn2 {
      z-index: 103;
      display: flex;
      align-items: center;
      justify-content: center;
      // position: fixed;
      // bottom: 0;
      // left: 0;
      width: 100%;
      line-height: 0.88rem;
      font-size: 0.32rem;
      color: #fff;
      background: #3078db;
      border-top: 1px solid #ebebeb;
    }
  }
</style>
